<div class="modal-header">
  <h6>Users in Cluster</h6>
  <button type="button" class="close-button" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div>
    Total: {{ totalUserCount }}
    @if (totalUserCount > 0) {
      <span>(page {{ page }} of {{ lastPage }})</span>
    }
    <span style="float:right; margin-right: 5px">
      @if (page > 1) {
        <i class="fa fa-chevron-left" style="cursor: pointer;" (click)="jumpPage(-1)" title="previous"></i>
      }
      &nbsp;&nbsp;&nbsp;&nbsp;
      @if (page < lastPage) {
        <i class="fa fa-chevron-right" style="cursor: pointer;" (click)="jumpPage(1)" title="next"></i>
      }
    </span>
  </div>
  <div style="width: 100%; height: 1px; background-color: #999; margin-top: 2px; margin-bottom: 5px"></div>
  <table style="font-size: 14px; background-color: rgba(0,0,0,0)">
    @for (user of users; track user) {
      <tr>
        <td>
          {{ user.name }}
          <img [src]="user.src" style="width: 12px; height: 12px">
          @if (user.visible) {
            <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)" style="width: 20px; height: 20px; margin-left: 5px" />
          }
          @if (!user.visible) {
            <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)" style="width: 20px; height: 20px; margin-left: 5px" />
          }
          @if (user.visible && user.status !== 'SUSPECT') {
            <i class="fa fa-info-circle" (click)="showUserInfo(user)" style="margin-left: 5px; padding-top: 5px"></i>
          }
          @if (user.visible && user.status === 'SUSPECT') {
            <i class="fa fa-info-circle" (click)="showUserInfo(user)" title="info"></i>
          }
        </td>
      </tr>
    }
  </table>
</div>